import styled from "styled-components";

export const NoCardWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  width: fit-content;
  img {
    border-radius: 0.5rem;
    box-shadow: 0 0 0.5rem black;
  }
  h2 {
    padding: 0 0 2rem 0;
  }
`;
